import Cookies from 'js-cookie';
import URLSearchParams from '@ungap/url-search-params';
import queryString from 'query-string';
import { REACT_APP_LOGIN_CHANNELS, REACT_COOKIE_EXPIRE_IN_MINUTES } from '../config';
import { QueryParams } from '../constants';
import { isTruthy } from './onp-util';
import { getDateSinceMinutes } from './cookie-util';
import { logToRemote } from './log-util';

export const persistQueryParamsToStorage = () => {
  try {
    const queryStr = window.location.search;
    const params = queryString.parse(queryStr);
    Object.keys(params).forEach((key) => {
      sessionStorage.setItem(key.toLowerCase(), params[key]);
      Cookies.set(key.toLowerCase(), params[key], { expires: getDateSinceMinutes(REACT_COOKIE_EXPIRE_IN_MINUTES) });
    });
    logToRemote({
      code: 200,
      level: 'info',
      src: 'param-util.js::persistQueryParamsToStorage',
      queryStrLen: queryStr.length,
      paramLen: Object.keys(params).length,
    });
  } catch (e) {
    logToRemote({
      code: 400,
      level: 'error',
      src: 'param-util.js::persistQueryParamsToStorage',
      desc: 'Exception occured at persistQueryParamsToStorage',
    });
  }
};

export function getQueryParamByKey(key) {
  return sessionStorage.getItem(key) || Cookies.get(key);
}

export function getParamsByQueryParamEnum() {
  const clientId = getQueryParamByKey(QueryParams.clientId);
  const scope = getQueryParamByKey(QueryParams.scope);
  const redirectUri = getQueryParamByKey(QueryParams.redirectUri);
  const responseType = getQueryParamByKey(QueryParams.responseType);
  const state = getQueryParamByKey(QueryParams.state);
  const channel = getQueryParamByKey(QueryParams.channel);

  return { channel, clientId, scope, redirectUri, responseType, state };
}

export function hasAppQueryParams() {
  let hasParams = true;
  const keysToCheck = [QueryParams.clientId, QueryParams.scope, QueryParams.redirectUri, QueryParams.responseType];
  keysToCheck.forEach((key) => {
    const value = getQueryParamByKey(key);
    if (!value || value === 'undefined' || value === 'null') hasParams = false;
  });
  return hasParams;
}

export function getChannelParam() {
  let channel = getQueryParamByKey(QueryParams.channel);

  if (typeof channel === 'string') {
    channel = channel.toLowerCase();

    if (REACT_APP_LOGIN_CHANNELS.has(channel)) {
      return channel;
    }
  }
  return null;
}

function shouldSetParam(params, queryIdName, queryIdValue) {
  return !isTruthy(params.get(queryIdName)) && isTruthy(queryIdValue);
}

export function getQueryParamString() {
  const { channel, clientId, scope, redirectUri, responseType, state } = getParamsByQueryParamEnum();
  const params = new URLSearchParams(window.location.search);

  if (shouldSetParam(params, QueryParams.channel, channel)) {
    params.set(QueryParams.channel, channel);
  }

  if (shouldSetParam(params, QueryParams.clientId, clientId)) {
    params.set(QueryParams.clientId, clientId);
  }

  if (shouldSetParam(params, QueryParams.redirectUri, redirectUri)) {
    params.set(QueryParams.redirectUri, redirectUri);
  }

  if (shouldSetParam(params, QueryParams.responseType, responseType)) {
    params.set(QueryParams.responseType, responseType);
  }

  if (shouldSetParam(params, QueryParams.scope, scope)) {
    params.set(QueryParams.scope, scope);
  }

  if (shouldSetParam(params, QueryParams.state, state)) {
    params.set(QueryParams.state, state);
  }

  return params.toString();
}
